import { Stack, Typography } from '@mui/material';
import { VyTooltip } from '../../../../components/new-design/VyTooltip';
import React from 'react';
import { sliceLongString } from '../../../../utils/string';

type LightInvoiceTitleDisplayProps = {
  value: string;
  title: string;
};

export const LightInvoiceTitleDisplay: React.FC<LightInvoiceTitleDisplayProps> = ({ value, title }) => (
  <Stack spacing={0.5}>
    <Typography
      variant="caption"
      sx={{
        color: '#7E8796',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 400,
      }}
    >
      {title}
    </Typography>
    <VyTooltip tooltipContent={value}>
      <Typography
        variant="body2"
        sx={{
          fontSize: '14px',
          lineHeight: '20px',
          fontWeight: 400,
        }}
      >
        {sliceLongString(value, 30)}
      </Typography>
    </VyTooltip>
  </Stack>
);
